import React from "react"
import { Card, CardContent, Typography, Box, useTheme } from "@mui/material"
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    ResponsiveContainer,
    Legend,
} from "recharts"

export default function LeadsByUTMChart({
    title = "Leads por UTM Source",
    data,
    totalLeads,
}) {
    const theme = useTheme()

    return (
        <Card sx={{ borderRadius: 1, boxShadow: 1 }}>
            <CardContent>
                <Typography variant="h6" color="text.secondary">
                    {`${title} (${totalLeads?.toLocaleString("pt-BR")})`}
                </Typography>

                <Box sx={{ height: 307 }}>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={70}
                                outerRadius={100}
                                paddingAngle={2}
                                isAnimationActive
                                labelLine={false}
                                label={({ value }) => `${value}`}
                            >
                                {data?.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={entry.color}
                                    />
                                ))}
                            </Pie>

                            <Tooltip
                                formatter={(value, name) => [
                                    `${value} leads`,
                                    name,
                                ]}
                                contentStyle={{
                                    backgroundColor:
                                        theme.palette.background.paper,
                                    borderColor: theme.palette.divider,
                                }}
                            />

                            <Legend
                                verticalAlign="bottom"
                                formatter={(value) => {
                                    const item = data?.find(
                                        (d) => d.name === value,
                                    )
                                    return `${value} (${item?.value ?? 0})`
                                }}
                            />
                        </PieChart>
                    </ResponsiveContainer>
                </Box>
            </CardContent>
        </Card>
    )
}
